<template>
  <div id="annonce-create-step-right-part" class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom">
    <div id="annonce-create-step-right-part-inside" class="col-12 pl-0 pr-0 mb-1" v-if="!isLoading">
      <transition-group name="listCustomTransition" tag="div" class="item-container-annonce">
        <div class="item-annonce" v-for="(annonce, index) in annonces" :key="index+'-annonce'">
          <div class="d-flex  justify-content-between">
            <p>{{annonce.brand.name + " - " + annonce.model.name}}</p>
          </div>
          <div  v-if="annonce.vehicleFiles.length>0">
            <img class="w-100 rounded" :src="annonce.vehicleFiles[0].url || getFileUrl(annonce.vehicleFiles[0].fileUrl)" alt="Annonce Image">
          </div>
          <div  v-else>
            <img class=" w-100 rounded no-result-img" :src="require(`@/assets/images/b122/PLACEHOLDER.png`)" alt="no result">
          </div>
          <div class="d-flex justify-content-between mt-2">
            <div class="d-flex align-items-center mr-1">
              <i class="ph ph-custom ph-scan main-color"></i>
              <div class="ml-2">{{formatAnnonceInfo(annonce)}}</div>
            </div>
            <div>
              <i v-for="index in 5" :class="(index <= annonce.additionnalRewardLevel.value ? 'ph-star-fill' : 'ph-star') + ' main-color'"></i>
            </div>
          </div>
          <div class="d-flex mt-1 price">
            {{AnnonceCreationUtils.getAnnonceTotalPrice(annonce)}}€
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";
import AnnonceCreationUtils from "../../../utils/AnnonceCreationUtils";

export default {
  name: "AnnonceCreatePaymentSummaryStep",

  components:{

  },

  emits: [],

  props: {
    annonces: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      AnnonceCreationUtils: AnnonceCreationUtils,

      isLoading:false,
    };
  },

  async mounted() {
    this.isLoading = true
    await Promise.all(this.annonces.map(async (annonce) => {
      annonce.model.name = await this.getModelNameById(annonce.model.value);
      annonce.brand.name = await this.getBrandNameById(annonce.brand.value);
    }));
    this.isLoading = false
  },

  methods: {
    async getModelNameById(modelId) {
      try {
        const response = await api.get(`/model/getNameById/${modelId}`);
        return response.data.name;
      } catch (error) {
        console.error("Error fetching model name", error);
        this.isLoading = false
        return "Unknown Model";
      }
    },

    async getBrandNameById(brandId) {
      try {
        const response = await api.get(`/brand/getNameById/${brandId}`);
        return response.data.name;
      } catch (error) {
        console.error("Error fetching brand name", error);
        this.isLoading = false
        return "Unknown Brand";
      }
    },


    formatAnnonceInfo(annonce) {
      let parts = [];
      if (annonce.licensePlate && annonce.licensePlate.value !== null) parts.push(annonce.licensePlate.value);
      if (annonce.vin && annonce.vin.value !== null) parts.push(annonce.vin.value);
      if (annonce.bicycode && annonce.bicycode.value !== null) parts.push(annonce.bicycode.value);
      if (annonce.serialNumber && annonce.serialNumber.value !== null) parts.push(annonce.serialNumber.value);

      return parts.join(' | ');
    },

    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },
  }
};
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-step-right-part {
    margin-top: -120px !important;
    height: calc(100% + 120px);
    overflow: auto;
  }
  #annonce-create-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.item-annonce{
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  border-radius: 10px;
  background-color: var(--main-black-medium);
  padding: 0.5rem;
  border: 1px solid var(--main-black-medium);
  margin-bottom: 5px;
}

.item-container-annonce{
  display: flex;
  flex-wrap: wrap;
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  gap: 2em;
}

.price{
  color: var(--main-yellow-medium);
  font-size: var(--menu-font-size);
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreatePaymentSummaryStep.vue